// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1awFW","range":"MonthRangeSwitch_range__3EWOu","disabled":"MonthRangeSwitch_disabled__2HeMy"};